/* eslint-disable camelcase */
import { useCallback, useEffect, useState } from 'react';
import type { MicroAppStateActions } from 'qiankun';
import { registerMicroApps, setDefaultMountApp, start, initGlobalState } from 'qiankun';
import { getWebsiteInfo } from '@/services/global';
import CustomizedHead from './components/CustomizedHead';

interface MainProps {
    prefix?: string;
}

function Main(props: MainProps): JSX.Element {
    const { prefix = '' } = props;

    const [globalInitialState, setGlobalInitialState] = useState<Record<string, any>>({
        logo: '',
        websiteInfo: {},
    });

    const init = useCallback(() => {
        registerMicroApps([
            {
                name: 'portal-fe',
                entry:
                    process.env.NODE_ENV === 'development'
                        ? `http://${process.env.CURRENT_IP}:3001/index.html`
                        : `${__webpack_public_path__}portal-fe/index.html`,
                container: 'main',
                activeRule: `${prefix}/portal`,
                props: {
                    domain:
                        process.env.NODE_ENV === 'development'
                            ? `http://${process.env.CURRENT_IP}:3001`
                            : __webpack_public_path__,
                    prefix,
                    logo: globalInitialState?.logo,
                    websiteInfo: globalInitialState?.websiteInfo,
                },
            },
            {
                name: 'supplier',
                entry:
                    process.env.NODE_ENV === 'development'
                        ? `http://${process.env.CURRENT_IP}:3002/index.html`
                        : `${__webpack_public_path__}supplier/index.html`,
                container: 'main',
                activeRule: `${prefix}/myProject`,
                props: {
                    domain:
                        process.env.NODE_ENV === 'development'
                            ? `http://${process.env.CURRENT_IP}:3002`
                            : __webpack_public_path__,
                    prefix,
                    logo: globalInitialState?.logo,
                },
            },
            {
                name: 'h5',
                entry:
                    process.env.NODE_ENV === 'development'
                        ? `http://${process.env.CURRENT_IP}:3003/index.html`
                        : `${__webpack_public_path__}h5/index.html`,
                container: 'main',
                activeRule: `${prefix}/mobile`,
                props: {
                    domain:
                        process.env.NODE_ENV === 'development'
                            ? `http://${process.env.CURRENT_IP}:3003`
                            : __webpack_public_path__,
                    prefix,
                },
            },
        ]);

        setDefaultMountApp(`${prefix}/portal`);

        // 如果遇到乾坤的Illegal invocation错误 点击一下界面在操作流程   这个情况只在开发环境出现
        start();
    }, [prefix, globalInitialState?.logo, globalInitialState?.websiteInfo]);

    useEffect(() => {
        const getAsyncWebsiteInfo = async () => {
            const data = await getWebsiteInfo();

            setGlobalInitialState(prev => ({ ...prev, logo: data?.logo, websiteInfo: data }));
        };

        getAsyncWebsiteInfo();
    }, []);

    useEffect(() => {
        // 初始化 state
        const actions: MicroAppStateActions = initGlobalState(globalInitialState);

        actions.setGlobalState(globalInitialState);

        return () => {
            actions.offGlobalStateChange();
        };
    }, [globalInitialState]);

    useEffect(() => {
        init();
    }, [init]);

    return (
        <main>
            <CustomizedHead websiteInfo={globalInitialState?.websiteInfo} />
        </main>
    );
}

export default Main;
